<template>
  <div v-if="price || limitPrice">
    <div v-if="type === '2'">
      <div class="add-top" v-if="price">
        <span v-if="showSymbolIcon === 'Y'" class="add-fuhao"> ¥ </span>
        <span>{{ getShowPrice((price || 0)- (limitPrice || 0)) }}</span>
        <span v-if="limitPrice > 0" class="fpp_limit_price">
          <span class="fuhao-add">+</span>
          <img class="sale-price-icon" :src="unionIcon" alt="fudou" />
          <span class="add-price">{{ getShowPrice(limitPrice) }}</span> 
        </span>
      </div>
    </div>
    <div class="money-part" v-else>
      <span>{{showSymbolIcon==='Y'?`¥${price || 0}`: `${price || 0}` }}</span>
      <div v-if="limitPrice > 0" class="money-decu">{{ `福豆可抵${limitPrice || 0}${showSymbolIcon==='Y'?'元':''}` }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      require: true,
    },
    price: {
      type: Number,
      required: true,
    },
    limitPrice: {
      type: Number,
      // required: true,
    },

    showSymbolIcon: {
      type: String,
      default: 'N',
    },

    unionIcon: {
      required: true,
    },

  },
  data() {
    return {
      unionScale: window.union_scale || 1,
    };
  },

  methods: {
    getShowPrice(price) {
      const _scale = window.union_scale || 1;
      return parseFloat((price * _scale).toFixed(2) || 0);
    },
  },
};
</script>
<style lang="less" scoped>
@375: 320/375;
.sale-price-icon {
  width: 12px * @375;
}
.add-top {
  margin-top: 10px * @375;
  font-size: 18px * @375;
  line-height: 24px * @375;
  font-weight: 600;
  color: #ff5757;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.add-fuhao{
  font-size: 18px * @375;
}
.fuhao-add{
  color: #999999;
  position: relative;
  top: -1px;
}
.money-part{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 18px * @375;
  font-weight: 600;
  color: #FF5757;
  margin-top: 10px;

  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.money-decu{
  background: #FF5757;
  border-radius: 8px * @375;
  line-height: 18px * @375;
  padding: 0 4px * @375;
  margin-left: 4px * @375;
  color: white;
  font-size: 12px * @375;
  font-weight: 400;

  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

}
</style>
